/**
 * Klab MMP Report API
 *
 * Contact: jesuspalominomartinez1234@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const NoExpectedReasonEnum = {
    Holiday: 'HOLIDAY',
    NotScheduled: 'NOT_SCHEDULED',
    NoSchedule: 'NO_SCHEDULE'
} as const;
export type NoExpectedReasonEnum = typeof NoExpectedReasonEnum[keyof typeof NoExpectedReasonEnum];
